import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const EditSavedSearchModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "EditSavedSearchModalContainer" */
      './EditSavedSearchModalContainer'
    ),
  loading: LoadingModal,
});
